<template>
    <div>
        <h3>ジャンルにまとめる</h3>
        <div>
            <p>
                ジャンルを追加して、作品をまとめることができます。
                ジャンルはシリーズと異なり、作品を束ねる機能や独立したページはありません。
                その代わり、本棚上で作品がジャンル別に表示されるようになります。
            </p>
            <p>
                ジャンルを作成しない場合、ジャンルに作品を登録しない場合、
                「その他」あるいは「小説」というジャンル名が表示されます。
            </p>
            <img src="/img/help/novel/39.png" alt="ジャンル" class="img-thumbnail mb-3">
            <h4>ジャンルを作成する</h4>
            <p>
                マイページのジャンルから、ジャンルを新規作成することができます。
                ジャンルに公開作品が追加されるまでは、本棚には当該ジャンルは表示されません。
            </p>
            <img src="/img/help/novel/40.png" alt="ジャンル新規作成" class="img-thumbnail mb-3">
            <p>
                ジャンルの説明は、ジャンル名の下に表示されます。
                読者にわかりやすい説明を記入してください。
                改行は削除されます。
            </p>
            <h4>ジャンルに作品を追加する</h4>
            <p>
                小説情報の編集からジャンルを設定することができます。
                ジャンルページから「小説一覧...」を表示して、そこから小説を選択してジャンルに登録したり、
                あるいは削除することができます。
            </p>
            <h4>ジャンルを削除する</h4>
            <p>
                追加したジャンルを削除する場合は、「削除」ボタンをクリックしてください。
                ジャンルだけが削除され、小説は削除されません。
                ジャンルが削除された場合、小説作品はジャンルなしになります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "ジャンルにまとめる | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>